
function WhatsappChannel() {
  return (
    <section id="whatsappChannel" className="intro-section spad">
      <div className="container">
        <div
          className="text-center row"
          style={{ display: "block !important" }}
        >
          <a
            href="https://whatsapp.com/channel/0029Vb6gqr25PO15p0S6Fc3Z" // 🔥 replace with your WhatsApp link
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={'whats-app-section-link.png'} alt="WhatsApp" style={styles.image} />
          </a>
        </div>
      </div>
    </section>
  );
}

const styles = {

  image: {
    width: '100%',
    borderRadius: "10px",
  },
};

export default WhatsappChannel;
